module.exports = __webpack_public_path__ + "media/images/default/shared/header/close-677e198369f639ff99bcdd75ffe8344b.svg";